import styled from 'styled-components';
import { FlexItemFlexible } from '@mews-commander/ui';
import { ListItemContainerElement, listItemFactory } from '@optimus-web/core';
import { getSpacingToken } from '@optimus-web/common';

const PrimaryText = styled.div``;

const LeftContentElement = styled.div`
    padding-right: ${getSpacingToken('100')}px;
`;

const NoActonBillListItemContainerElement = styled(ListItemContainerElement)`
    &:hover {
        cursor: unset;
    }
`;

export const NoActionBillListItem = listItemFactory({
    Content: FlexItemFlexible,
    PrimaryText,
    LeftContent: LeftContentElement,
    ListItemContainer: NoActonBillListItemContainerElement,
});

export default listItemFactory({
    Content: FlexItemFlexible,
    PrimaryText,
    LeftContent: LeftContentElement,
});
